import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetHarvestPlansInputDto, HarvestPlanCreateDto, HarvestPlanDto, HarvestPlanExcelDownloadDto, HarvestPlanUpdateDto, ImportHarvestPlansInputDto } from '../dtos/harvest-plan/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class HarvestPlanService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: HarvestPlanCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestPlanDto>({
      method: 'POST',
      url: '/api/operational/harvestPlans',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/harvestPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/harvestPlans',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestPlanDto>({
      method: 'GET',
      url: `/api/operational/harvestPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/harvestPlans/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetHarvestPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<HarvestPlanDto>>({
      method: 'GET',
      url: '/api/operational/harvestPlans',
      params: { team: input.team, costReceiverId: input.costReceiverId, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, validDate: input.validDate, validDateFrom: input.validDateFrom, validDateTo: input.validDateTo, volume: input.volume, volumeFrom: input.volumeFrom, volumeTo: input.volumeTo, planVersion: input.planVersion, planNumber: input.planNumber, planNumberFrom: input.planNumberFrom, planNumberTo: input.planNumberTo, planTypeId: input.planTypeId, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: HarvestPlanExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/harvestPlans/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, team: input.team, costReceiverId: input.costReceiverId, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, validDate: input.validDate, validDateFrom: input.validDateFrom, validDateTo: input.validDateTo, volume: input.volume, volumeFrom: input.volumeFrom, volumeTo: input.volumeTo, planVersion: input.planVersion, planNumber: input.planNumber, planNumberFrom: input.planNumberFrom, planNumberTo: input.planNumberTo, planTypeId: input.planTypeId, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestPlanDto[]>({
      method: 'GET',
      url: '/api/operational/harvestPlans/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  import = (input: ImportHarvestPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestPlanDto[]>({
      method: 'POST',
      url: '/api/operational/harvestPlans/import',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: HarvestPlanUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestPlanDto>({
      method: 'PUT',
      url: `/api/operational/harvestPlans/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}